import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState } from 'react';
import styled from 'styled-components';
import { Box, InputLabel, Section } from '@miro-site/core';
import { LazyImageAdapter, Headline, ButtonAdapter } from '@miro-site/components_utils';
import { theme } from '@miro-site/design-tokens';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled(Box).attrs({
  $py: [64, 128],
  $px: [20, 64],
  $styles: {
    backgroundColor: theme.colors.primaryIndigo,
    position: 'relative',
    overflow: 'hidden'
  }
}).withConfig({
  displayName: "InlineFormToSignUp__Wrapper",
  componentId: "sc-8bhawe-0"
})([""]);
var ShapeContainer = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: [null, 960],
    height: [null, 830]
  }
}).withConfig({
  displayName: "InlineFormToSignUp__ShapeContainer",
  componentId: "sc-8bhawe-1"
})([""]);
var Shape = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    top: 0,
    left: '26%',
    width: [null, 960]
  }
}).withConfig({
  displayName: "InlineFormToSignUp__Shape",
  componentId: "sc-8bhawe-2"
})([""]);
var Elements = styled(Box).attrs({
  $styles: {
    position: 'relative',
    zIndex: 3
  }
}).withConfig({
  displayName: "InlineFormToSignUp__Elements",
  componentId: "sc-8bhawe-3"
})([""]);
var FormContainer = styled(Box).attrs({
  $mt: [40, 72],
  $styles: {
    display: 'flex'
  }
}).withConfig({
  displayName: "InlineFormToSignUp__FormContainer",
  componentId: "sc-8bhawe-4"
})(["form{display:flex;margin:auto;", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    flexDirection: ['column', null],
    width: ['100%', null]
  });
});
var ButtonContainer = styled(Box).attrs({
  $px: [null, 4],
  $mt: [16, null]
}).withConfig({
  displayName: "InlineFormToSignUp__ButtonContainer",
  componentId: "sc-8bhawe-5"
})([""]);

var InlineFormToSignUp = function InlineFormToSignUp(_ref2) {
  var headline = _ref2.headline,
      shape = _ref2.shape,
      button = _ref2.button,
      targetUrl = _ref2.targetUrl;

  var _useState = useState(''),
      name = _useState[0],
      setName = _useState[1];

  var _useState2 = useState(''),
      email = _useState2[0],
      setEmail = _useState2[1];

  var handleNameChange = function handleNameChange(e) {
    setName(String(e.target.value));
  };

  var handleEmailChange = function handleEmailChange(e) {
    setEmail(String(e.target.value));
  };

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    var params = new URLSearchParams();

    if (name) {
      params.append('name', escapeHtml(name));
    }

    if (email) {
      params.append('email', escapeHtml(email));
    }

    window.location.assign("".concat(targetUrl, "?").concat(params.toString()));
  };

  var escapeHtml = function escapeHtml(text) {
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, function (m) {
      return map[m];
    });
  };

  return /*#__PURE__*/_jsx(Section, {
    "data-place": "Signup Form",
    $styles: {
      textAlign: 'center'
    },
    children: /*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsxs(Elements, {
        children: [headline && /*#__PURE__*/_jsx(Headline, _objectSpread({
          tag: "h2",
          align: "center",
          size: "mid",
          color: "white",
          headingProps: {
            $styles: {
              maxWidth: 645,
              margin: 'auto'
            }
          }
        }, headline)), /*#__PURE__*/_jsx(FormContainer, {
          children: /*#__PURE__*/_jsxs("form", {
            onSubmit: handleSubmit,
            noValidate: true,
            children: [/*#__PURE__*/_jsx(InputLabel, {
              type: "text",
              name: "name",
              value: name,
              label: 'Name',
              onChange: handleNameChange
            }), /*#__PURE__*/_jsx(InputLabel, {
              type: "email",
              name: "email",
              value: email,
              label: 'Work email',
              onChange: handleEmailChange
            }), /*#__PURE__*/_jsx(ButtonContainer, {
              children: /*#__PURE__*/_jsx(ButtonAdapter, _objectSpread(_objectSpread({
                $styles: {
                  paddingLeft: [null, 4],
                  paddingRight: [null, 8],
                  paddingTop: [4, 4],
                  paddingBottom: [3, 4],
                  borderRadius: 36,
                  width: ['100%', null]
                },
                arrow: true
              }, button), {}, {
                href: null
              }))
            })]
          })
        })]
      }), shape && /*#__PURE__*/_jsx(ShapeContainer, {
        children: /*#__PURE__*/_jsx(Shape, {
          children: /*#__PURE__*/_jsx(LazyImageAdapter, {
            assets: shape
          })
        })
      })]
    })
  });
};

export default InlineFormToSignUp;